export default function getAnalyticsMiddleware(analyticsMap) {
	return ({ getState }) => (next) => (action) => {
		// for each package, pass it the state and action
		Object.keys(analyticsMap).forEach((reducerName) => {
			const reducer = analyticsMap[reducerName];
			const state = getState();
			reducer(state[reducerName], action);
		});
		return next(action);
	};
}



// WEBPACK FOOTER //
// ./src/shared/redux/getAnalyticsMiddleware.js